import { isFeatureEnabled } from 'common/utils';
import { UrlName } from 'modules/app/types';

export interface ConfigServiceI {
  urls: Record<UrlName, string | undefined>;
  getUrl(name: UrlName): string;
}

class ConfigService implements ConfigServiceI {
  urls: ConfigServiceI['urls'];

  constructor() {
    this.urls = {
      api: window._env_.VITE_APP_API_URL,
      auth: window._env_.VITE_APP_AUTH_URL,
      authApi: window._env_.VITE_APP_PASSWORDLESS_AUTH_API_URL,
      base: window._env_.VITE_APP_API_BASE_URL,
      openNatterApi: window._env_.VITE_APP_OPEN_NATTER_API_URL,
      openNatterWs: window._env_.VITE_APP_OPEN_NATTER_WS_URL,
      tagApi: window._env_.VITE_APP_TAG_API_URL,
    };
  }

  getUrl(name: UrlName): string {
    const url = this.urls[name];

    if (!url && name === 'openNatterApi') {
      throw new Error('VITE_APP_OPEN_NATTER_API_URL environment variable is required');
    }
    if (!url && name === 'openNatterWs') {
      throw new Error('VITE_APP_OPEN_NATTER_WS_URL environment variable is required');
    }
    if (!url && name === 'authApi' && isFeatureEnabled('EnablePasswordlessMagicLinks')) {
      throw new Error(
        'VITE_APP_PASSWORDLESS_AUTH_API_URL environment variable is required when EnablePasswordlessMagicLinks feature is enabled'
      );
    }

    return url as string;
  }
}

export default ConfigService;
